import { HttpContext, HttpContextToken } from '@angular/common/http';
import { InjectionToken } from '@angular/core';
import { ITrackerConfig, ITrackerHttpContext, ITrackerParams } from '../interface';

export const TRACKER_CONFIG = new InjectionToken<ITrackerConfig>('TRACKER_CONFIG');
export const TRACKER_PARAMS = new InjectionToken<ITrackerParams>('TRACKER_PARAMS');
export const TRACKER_CONTEXT = new InjectionToken<HttpContext>('TRACKER_CONTEXT');
export const TRACKER_HTTP_CONTEXT = new HttpContextToken<ITrackerHttpContext>(() => ({}));